module.exports = __webpack_public_path__ + "staticcomp/img/content_2副本.8ebf2c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/5/content_2副本.jpg
// module id = 3WVi
// module chunks = 39